// extracted by mini-css-extract-plugin
export default {"customCell":"tablestyles_customCell__Xe6mb","customHeader":"tablestyles_customHeader__w1clj"};